<template>
  <div class="home">
    <section class="hero is-transparent is-medium has-text-centered container" id="overview">
      <div class="hero-body">
        <p class="title">
          {{$t("con.headline")}}
        </p>
        <p class="subtitle mt-3">
          {{$t("con.text")}}
        </p>
        <!-- showModal('install') -->
        <b-button @click="showModal('contact')" class="mt-5 mr-2" size="is-medium" type="is-primary">{{$t("btn.contact")}}</b-button>
        <b-button @click="showModal('install')" class="mt-5" size="is-medium" type="is-success">{{$t("btn.download")}}</b-button>
      </div>
    </section>

    <section class="section is-medium widgets has-text-centered">
      <div class="container">
        <div class="title">
          {{$t("con.headline2")}}
        </div>
        <div class="subtitle">
          {{$t("con.text2")}}
        </div>
        <div class="columns mt-6">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="clipboard-list-check"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title1")}}</p>
              <p class=" mt-2">{{$t("con.block.text1")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="note-sticky"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title2")}}</p>
              <p class=" mt-2">{{$t("con.block.text2")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-first" icon="calendar-alt"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title3")}}</p>
              <p class=" mt-2">{{$t("con.block.text3")}}</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="list-timeline"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title4")}}</p>
              <p class=" mt-2">{{$t("con.block.text4")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="cloud"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title5")}}</p>
              <p class="mt-2">{{$t("con.block.text5")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-second" icon="clock"></b-icon>
              <p class="box-title mt-2">{{$t("con.block.title6")}}</p>
              <p class="mt-2">{{$t("con.block.text6")}}</p>
            </div>
          </div>
        </div>
        <div class="subtitle">
          {{$t("misc.more")}}
        </div>
      </div>
    </section>

    <section id="testimonials" class="section is-medium testimonials has-text-centered">
      <div class="container">
        <div class="title">
          {{$t("con.headline3")}}
        </div>
        <div class="subtitle">
          {{$t("con.text3")}}
        </div>
        <div class="columns mt-6">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="twitter"></b-icon>
              <p class="mt-2">{{$t("con.test.text1")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="firefox"></b-icon>
              <p class=" mt-2">{{$t("con.test.text2")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="chrome"></b-icon>
              <p class=" mt-2">{{$t("con.test.text3")}}</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="firefox"></b-icon>
              <p class=" mt-2">{{$t("con.test.text4")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="edge"></b-icon>
              <p class="mt-2">{{$t("con.test.text5")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="telegram"></b-icon>
              <p class="mt-2">{{$t("con.test.text6")}}</p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="chrome"></b-icon>
              <p class=" mt-2">{{$t("con.test.text7")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="facebook"></b-icon>
              <p class="mt-2">{{$t("con.test.text8")}}</p>
            </div>
          </div>
          <div class="column">
            <div class="box-black">
              <b-icon class="icon-white" icon="twitter"></b-icon>
              <p class="mt-2">{{$t("con.test.text9")}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="faq" class="section is-medium faq has-text-centered">
      <div class="container">
        <div class="title">
          {{$t("con.headline4")}}
        </div>
        <div class="subtitle">
          {{$t("con.text4")}}
        </div>

        <div class="has-text-left has-text-white">
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              {{$t("con.faq.question1")}}
            </div>
            <div class="column">
              {{$t("con.faq.text1")}}
            </div>
          </div>
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              {{$t("con.faq.question2")}}
            </div>
            <div class="column">{{$t("con.faq.text2")}}</div>
          </div>
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              {{$t("con.faq.question3")}} 
            </div>
            <div class="column">{{$t("con.faq.text3")}}</div>
          </div>
          <div class="columns mt-6">
            <div class="column is-one-third has-text-weight-bold">
              {{$t("con.faq.question4")}} 
            </div>
            <div class="column">{{$t("con.faq.text4")}}</div>
          </div>
        </div>
      </div>
    </section>

    <section id="video" class="section is-medium video-section-block has-text-centered">
      <div class="container">
        <div class="title">
          {{$t("con.headline5")}}
        </div>
        <div class="subtitle">
          {{$t("con.text5")}}
        </div>

        <div class="video-section">
          <div class="video-box">     
            <iframe class="video" src="https://www.youtube.com/embed/svYajwMO0AQ?si=p-ezGLeXeew0fxqw" title="CyberFox Guard - All-in-one Corporate Secure Access Solution" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>  
      </div>
    </section>
    
  </div>
  </template>

<script>
export default {
  name: 'HomeView',
  methods: {
    showModal(modal) {
      console.log("showing modal");
      this.$store.commit("showModal", modal);
    },
    openOnline(){
      window.open("https://online.cyberfoxguard.com/", '_blank');
    },
  },
  mounted() {
    //this.$scrollTo('#faq', 500);
  },
  watch: {
    $route(to, from) {
      if (to.hash === "#faq") {
        this.$scrollTo('#faq', 500);
      }
      if (to.hash === "#testimonials") {
        this.$scrollTo('#testimonials', 500);
      }
      if (to.hash === "#overview") {
        this.$scrollTo('#overview', 500);
      }
    }
  },
  metaInfo() {
    return {
      title: "Cyberfox Guard - All-in-one Corporate Secure Access Solution.",
      htmlAttrs: {
        lang: "en"
      },
      meta: [
        {
          name: "description",
          content: "Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure."
        },
        {
          property: "og:title",
          content: "Cyberfox Guard - All-in-one Corporate Secure Access Solution.",
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: "Cyberfox Guard is a suite of aplications and extensions dedicated to make your company accounts access more secure.",
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: "https://cyberfoxguard.com/img/share.png",
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: "https://cyberfoxguard.com",
          vmid: "og:url"
        }
      ]
    };
  } //end meta
}
</script>
<style scoped>

.hero .title{
  /* text-transform: uppercase; */
  font-size: 3.2rem;
  font-weight: 900;
}

.hero .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.widgets .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.widgets .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.testimonials{
  background-color: #0b0c0c;
}

.testimonials .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.testimonials .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.faq .title{
  /* text-transform: uppercase; */
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
}

.faq .subtitle{
  color: rgb(173, 173, 173)!important;
  font-size: 1.5rem;
}

.video-section-block{
  background-color: #0b0c0c;
}

.video-section{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video-box{
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.box-black {
  background-color: #1b1c1d;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-blue {
  background-color: #0068cf3a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-orange {
  background-color: #cf6e003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-red {
  background-color: #cf00003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-green {
  background-color: #00cf003a;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: #fff;
  display: block;
  padding: 2.25rem;
  margin: 0 20px 0 20px;
  text-align: left;
}

.box-title {
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.icon-first{
  font-size: 3rem;
  color:#47F8CC;
}

.icon-second{
  font-size: 3rem;
  color:#25BADA;
}

.icon-third{
  font-size: 3rem;
  color:#0278E8;
}

.icon-white{
  font-size: 2rem;
  color:#ffffff;
}

</style>
